const AddItemSnackbar = ({ handleAddToCollection }: any) => {
  return (
    <>
      <div className="add-item-snackbar">
        <img src="/heart-fill-white.svg" />{" "}
        <div className="snackbar-right">
          <span>Item added to your favorites</span>
          <div className="add-action" onClick={handleAddToCollection}>
            Add to collection
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .add-item-snackbar {
            display: flex;
            align-items: center;

            > img {
              width: 16px;
              height: 16px;
              margin-right: 8px;
            }

            .snackbar-right {
              display: flex;
              align-items: center;

              .add-action {
                margin-left: 56px;
                text-decoration: underline;
                cursor: pointer;
              }
            }
          }
          @media (max-width: 768px) {
            .add-item-snackbar {
              align-items: start;

              > img {
                margin-top: 4px;
              }

              .snackbar-right {
                flex-direction: column;
                align-items: start;

                .add-action {
                  margin-left: 0px;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default AddItemSnackbar;
